import { ConditionReport } from "@skinsoft/types";
import { dbCacheUp } from "../dexie/cache-up";
import { OfflineDataUpdateCacher } from "../offline-data-update-cacher";

export class ConditionReportOfflineDataUpdateCacher extends OfflineDataUpdateCacher<ConditionReport> {
    constructor() {
        super(dbCacheUp.conditionReport)
    }
}